import apis, { JobManager } from './services.api';

export type { JobManager };
export type JobManagerWithFunction = JobManager & { function: string };

export async function getJobManagers(contactsFunction: string): Promise<JobManager[]> {
  return apis.getJobManagers(contactsFunction);
}

export async function markAsAlreadyHadAppointment(
  fullName: string,
  contactsFunction: string,
  emailAddress: string,
): Promise<void> {
  return apis.markAsAlreadyHadAppointment(fullName, contactsFunction, emailAddress);
}

export default {
  getJobManagers,
  markAsAlreadyHadAppointment,
};
